import typeToReducer from 'type-to-reducer'
import {
    GET_CUSTOMERS_LIST_SUCCESS,
    GET_CUSTOMERS_LIST_FAIL,
    GET_SINGLE_CUSTOMER_SUCCESS,
    GET_SINGLE_CUSTOMER_FAIL,
    GET_CUISINE_SUCCESS,
    GET_FOOD_CATEGORIES_SUCCESS,
    GET_ZONES_SUCCESS,
    GET_MENU_SUCCESS,
    GET_TAGS_SUCCESS,
    GET_LIST_ITEMS_SUCCESS,
    GET_ITEMS_SUCCESS,
    START_GET_CUSTOMER } from '../actions/actionTypes';



const initialState = {
    customers: null,
    customer: null,
    customersPageCount: null,
    foodCategories: null,
    cuisines: null,
    freeDrivers: null,
    zones: null,
    menu: null,
    tags: null,
    listItems: null,
    pageCount: null,
    items: null,
    error: null,
    assignError: null
};

const reducer = typeToReducer({
    [GET_CUSTOMERS_LIST_SUCCESS]: (state, action) => ({
        ...state,
        customers: action.payload.results,
        customersPageCount: Math.ceil(action.payload.count / 10),
        error: null
    }),
    [START_GET_CUSTOMER]: (state, action) => {
        return {
            ...state,
            customer: null
        }
    },
    [GET_CUSTOMERS_LIST_FAIL]: (state, action) => ({
        ...state,
        error: action.error
    }),
    [GET_SINGLE_CUSTOMER_SUCCESS]: (state, action) => ({
        ...state,
        customer: action.payload,
        error: null
    }),
    [GET_SINGLE_CUSTOMER_FAIL]: (state, action) => ({
        ...state,
        error: action.error
    }),
    [GET_CUISINE_SUCCESS]: (state, action) => ({
        ...state,
        cuisines: action.payload.results,
        error: null
    }),
    [GET_FOOD_CATEGORIES_SUCCESS]: (state, action) => ({
        ...state,
        foodCategories: action.payload.results,
        error: null
    }),
    [GET_ZONES_SUCCESS]: (state, action) => ({
        ...state,
        zones: action.payload,
        error: null
    }),
    [GET_MENU_SUCCESS]: (state, action) => ({
        ...state,
        menu: action.payload.results,
        error: null
    }),
    [GET_TAGS_SUCCESS]: (state, action) => ({
        ...state,
        tags: action.payload.results,
        error: null
    }),
    [GET_LIST_ITEMS_SUCCESS]: (state, action) => {
        return {
            ...state,
            listItems: action.payload.results,
            pageCount: Math.ceil(action.payload.count / 10)
        }
    },
    [GET_ITEMS_SUCCESS]: (state, action) => {
        return {
            ...state,
            items: action.payload.results,
            pageCount: Math.ceil(action.payload.count / 10)
        }
    },
    'GET_FREE_DRIVER_SUCCESS': (state, action) => {
        return {
            ...state,
            freeDrivers: action.payload
        }
    },
    'ASSIGN_ERROR': (state, action) => {
        return {
            ...state,
            assignError: action.assignError
        }
    },
    'MENU_NAME': (state, action) => {
        return {
            ...state,
            menuName: action.payload
        }
    },
    'MENU_NAME_START': (state, action) => {
        return {
            ...state,
            menuName: null
        }
    }
}, initialState);


export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/customer.js